export default __webpack_public_path__ + "static/media/card_best_performance.f1cde2bb.png";